module.exports = __webpack_public_path__ + "static/media/imagenArticle1.452d0426.jpg";